import { EventBus } from "@/event-bus";
const estadosMixins = {
    data() {
        return {
            activities: []
        }
    },
    methods: {
        goToMenu(menu)
        {
          EventBus.$emit('goToMenu', menu);
        },
        getEstadoPedido(datos) {
            let dataEstado = {};
            let texto = {};
            let vtex = datos;
            texto.btnEnvio = true
            texto.verTimeline = true
            // console.log("getEstadoPedido(datos)", this.dataVtex);
            //generales
            dataEstado.ultimo_estado = datos.sc_ultimo_estado
                ? datos.sc_ultimo_estado
                : false;
            // console.warn(datos);
            let fechaEntrega = datos.fecha_estimada
                ? datos.fecha_estimada.date
                : false;

            if (fechaEntrega) {
                if ([0, 6].includes(this.$date(fechaEntrega).day())) {
                    dataEstado.fecha_estimada = this.$date(fechaEntrega).add(1, "day").format("DD/MM/YYYY");
                } else {
                    dataEstado.fecha_estimada = this.$date(fechaEntrega).format("DD/MM/YYYY");
                    
                }
            } else {
                dataEstado.fecha_estimada =  "7 días habiles a partir de la compra";
            }
           
            dataEstado.fecha_max = datos.fecha_estimada
                ? this.$date(datos.fecha_estimada.date).add(30, "day").format("DD/MM/YYYY")
                : "30 días para retirarlo";
            dataEstado.fecha_estado =
                datos.fecha_ultimo_estado && datos.fecha_ultimo_estado.date
                    ? this.$date(datos.fecha_ultimo_estado.date).format("DD/MM/YYYY")
                    : "-";
            dataEstado.fecha_noentregado =
                datos.fecha_ultimo_estado && datos.fecha_ultimo_estado.date
                    ? this.$date(datos.fecha_ultimo_estado.date)
                        .add(30, "day")
                        .format("DD/MM/YYYY")
                    : "-";
            dataEstado.fecha_entrega = fechaEntrega ? this.$date(fechaEntrega).format("dddd D [de] MMMM") : "7 días habiles a partir de la compra";
            dataEstado.fecha_estado = this.$date(datos.fecha_ultimo_estado.date).format("L")
            dataEstado.fecha_hora_estado = this.$date(datos.fecha_ultimo_estado.date).format("DD/MM/YYYY HH:mm")

            //punto de retiro
            dataEstado.pdr = {
                nombre: datos.name,
                direccion: datos.street ? `${datos.street.toUpperCase()} ${datos.number
                    } - ${datos.state.toUpperCase()}(${datos.postalCode})` : "",
                horarios: datos.instructions,
                maps: datos.latitude
                    ? `https://maps.google.com/?q=${datos.latitude},${datos.longitude}`
                    : false,
            };
            //domicilio cliente
            dataEstado.direccion_cliente = datos.envio_domicilio
                ? datos.envio_domicilio
                : {};

            dataEstado.reclamo = datos.datos_reclamo && datos.datos_reclamo.length ? datos.datos_reclamo[0] : {}
            //   let texto = dataEstado;
            switch (dataEstado.ultimo_estado) {
                case 10: //en preparacion
                    if (datos.envio) {
                        texto.titulo = `Estamos preparando tu pedido, la fecha de entrega estimada es  
		                         <strong>${dataEstado.fecha_estimada.substring(
                            10,
                            0
                        )}</strong>`;
                        texto.entrega = `Entregaremos tu pedido el ${dataEstado.fecha_entrega}
		                         <small>Te enviaremos una notificación cuando estemos en camino a tu domicilio.</small>`;

                    } else {
                        texto.titulo = `Estamos preparando tu pedido, La fecha de entrega estimada para que retires tu pedido es: 
		                         <strong>${dataEstado.fecha_estimada}</strong>`;
                        texto.entrega = `Tu pedido llegará a la farmacia el ${dataEstado.fecha_entrega}
		                         <small>Te enviaremos una notificación cuando llegue para que lo retires.</small>`;
                    }

                    // this.activities[0].timestamp = datos.fecha_ultimo_estado.date
                    break;
                case 20:
                    if (datos.envio) {
                        texto.titulo = `Estamos preparando tu pedido, la fecha estimada de entrega es:  
		                         <strong>${dataEstado.fecha_estimada.substring(
                            10,
                            0
                        )}</strong>`;
                        texto.entrega = `Entregaremos tu pedido el ${dataEstado.fecha_entrega}
		                         <span>Te enviaremos una notificación cuando estemos en camino a tu domicilio.</span>`;

                    } else {
                        texto.titulo = `Tu pedido se encuentra en camino hacia el punto de retiro, La fecha estimada desde la cual podrás retirar tu pedido es: 
		                  <strong>${dataEstado.fecha_estimada}</strong>`;
                        texto.entrega = `Tu pedido llegará a la farmacia el ${dataEstado.fecha_entrega}
		                         <span>Te enviaremos una notificación cuando llegue para que lo retires.</span>`;
                    }

                    break;
                case 30:
                    texto.titulo = `Tu pedido <strong>llegó al punto de retiro</strong> y estará disponible para que lo retires hasta el 
		                     <strong>${dataEstado.fecha_max}</strong>. <br>
						     <span>Punto de retiro seleccionado: 
							  <strong style="color:#333">- ${dataEstado.pdr.nombre}</strong>
							 </span>`;
                    texto.entrega = `Tu pedido llegó al punto de retiro el ${dataEstado.fecha_estado}
		                         <span>Ya podés retirar tu pedido en los horarios: ${dataEstado.pdr.horarios.toLowerCase()}</span>`;
                    // this.activities[2].content = 'El pedido llegó al punto de retiro'
                    break;
                case 31:
                    texto.titulo = `Tu pedido está en camino a tu domicilio, pronto un repartidor entregará tu pedido en: 
						    
							  <strong style="color:#333">${dataEstado.direccion_cliente.direccion}</strong>
							 `;
                    texto.entrega = `Tu pedido llegó al punto de distribución el ${dataEstado.fecha_estado}
		                         <small>Pronto, un repartidor llevará el pedido a tu domicilio`;
                    // this.activities[2].content = 'El pedido llegó al centro de distribución'
                    // this.activities[2].timestamp = dataEstado.fecha_estado
                    // this.activities[2].color = "#0bbd87"
                    break;
                case 32:

                    // this.activities[2].content = `Retornó a farmacia. Envio a domicilio no concretado <br>  - Motivo <strong>${datos.estado_treggo_descript.replace(
                    //     "Treggos",
                    //     "repartidores"
                    // ) || "no especificado"
                    //     }</strong>
                    //    `
                    // this.activities[2].timestamp = dataEstado.fecha_hora_estado
                  
                    // this.activities[3].content = `Pedido disponible para retirar en la farmacia. Presentar DNI `
                   
                    texto.titulo = `El repartidor no pudo entregar tu pedido en <strong style="color:#333">${dataEstado.direccion_cliente.direccion
                        }</strong><br />
                         - Motivo: ${datos.estado_treggo_descript.replace(
                            "Treggos",
                            "repartidores"
                        ) || "no especificado"
                        }
                         <br />
                         <strong>
                         Tu pedido estará disponible hasta el día ${dataEstado.fecha_noentregado
                        } en la farmacia:
                         </strong> <br>
                         <ul>
                           <li>
                             ${dataEstado.pdr.nombre} 
                           </li>
                            <li>
                             ${dataEstado.pdr.direccion} 
                           </li>
                             <li>
                             ${dataEstado.pdr.horarios} 
                           </li>
                            <li>
                               <a href="${dataEstado.pdr.maps
                        }" target="blank">VER MAPA</a>
                           </li>
                         </ul> `;
                    texto.noentrega = `El repartido no pudo entregar el pedido por el siguiente motivo: <br>   <strong>${datos.estado_treggo_descript.replace(
                        "Treggos",
                        "repartidores"
                    ) || "no especificado"
                        }  </strong>
                         <br />
                         <strong>
                         Podés retirar tu pedido presentando tu DNI en la farmacia:
                        
                         <ul>
                           <li>
                             ${dataEstado.pdr.nombre} 
                           </li>
                            <li>
                             ${dataEstado.pdr.direccion} 
                           </li>
                             <li>
                             ${dataEstado.pdr.horarios} 
                           </li>
                            <li>
                               <a href="${dataEstado.pdr.maps
                        }" target="blank">VER MAPA</a>
                           </li>
                         </ul> 
                         
                          Tu pedido estará disponible hasta el día ${dataEstado.fecha_noentregado
                        } sino retirás hasta esa fecha, procederemos con la cancelación del pedido y la devolución del dinero:
                         </strong> <br>`;
                    texto.entrega = `No pudimos concretar la entrega a domicilio
		                         <small>El repartidor no pudo entregar tu pedido en <strong style="color:#000">${dataEstado.direccion_cliente.direccion
                        } y tu pedido regresó al punto de distribución.`;
                    texto.btnEnvio = false;
                    texto.verTimeline = false;




                    break;
                case 40:
                case 50:
                    texto.titulo = `<strong>Pedido entregado</strong>  el día
		                     <strong>${dataEstado.fecha_estado}*.</strong><br>
						     <small style="display:block; line-height:1; font-size:14px">* la fecha de entrega es informada por el punto de retiro y puede ser distinta a la fecha que retiraste el pedido</small>`;
                    texto.entrega = `Retiraste tu pedido el día ${dataEstado.fecha_estado}
		                          <small style="display:block; line-height:1; font-size:14px">La fecha de entrega es informada por el punto de retiro y puede ser distinta a la fecha que retiraste el pedido</small>`;
                    // this.activities[2].content = 'El pedido llegó al punto de retiro'
                    // this.activities[3].content = 'Retiraste tu pedido'
                    //  this.activities[2].timestamp = dataEstado.fecha_estado
                    //  this.activities[2].color = "#0bbd87"
                    break;
                case 41:
                    texto.titulo = `<strong>Pedido entregado</strong>  el día
		                     <strong>${dataEstado.fecha_estado}*.</strong><br>
						     <small style="display:block; line-height:1; font-size:14px">* la fecha de entrega es informada por el punto de retiro y puede ser distinta a la fecha que retiraste el pedido</small>`;
                    texto.entrega = `Entregamos tu pedido el día ${dataEstado.fecha_estado}
		                          `;

                    // this.activities[3].content = 'Entrega realizada'
                    break;
            }

            if (dataEstado.reclamo && dataEstado.reclamo.id) {
                switch (dataEstado.reclamo.motivo_id) {
                    case 12:
                        texto.titulo = `Solicitaste la cancelación de tu pedido el día <strong>${this.$date(dataEstado.reclamo.fecha_creacion.date).format('LLL')}</strong></p>`;
                        texto.entrega = `Solicitaste la cancelación de tu pedido el día <strong>${this.$date(dataEstado.reclamo.fecha_creacion.date).format('LLL')}</strong></p>`;

                        texto.btnEnvio = false;
                        texto.verTimeline = false;
                        break;
                    case 11:
                        texto.titulo = `Solicitaste la cancelación de tu pedido el día <strong>${this.$date(dataEstado.reclamo.fecha_creacion.date).format('LLL')}</strong></p>`;
                        texto.entrega = `Solicitaste la cancelación de tu pedido el día <strong>${this.$date(dataEstado.reclamo.fecha_creacion.date).format('LLL')}</strong></p>`;

                        texto.btnEnvio = false;
                        texto.verTimeline = false;
                        break;
                    case 3:
                        texto.titulo = `<strong>Pedido demorado</strong>: estamos verificando que sucedio con tu pedido
                                          <ul>
                                             <li>N° de reclamo: <strong>${dataEstado.reclamo.number_case}</strong></li>
                                             <li>Fecha de reclamo: ${this.$date(dataEstado.reclamo.fecha_creacion.date).format('LLL')}</li>
                                          </ul>
                                          `;
                        texto.entrega = `Solicitaste la cancelación de tu pedido el día <strong>${this.$date(dataEstado.reclamo.fecha_creacion.date).format('LLL')}</strong></p>`;

                        texto.btnEnvio = true;
                        texto.verTimeline = true;
                        // this.activities[1].color = "#ff9800"
                        // this.activities[2].color = "#ff9800"
                        // this.activities[3].color = "#f44336"
                        // this.activities[3].content = 'Pedido demorado'
                        // this.activities[3].timestamp = this.$date(dataEstado.reclamo.fecha_creacion.date).format('LLLL')
                        break;



                }
            }
            return texto;
        },
    },
}

export default estadosMixins;